export type SetFeatureFlags = { type: 'featureFlags::set'; flags: Record<string, unknown> };

export const setFeatureFlags = (flags: Record<string, unknown>): SetFeatureFlags => ({
    type: 'featureFlags::set',
    flags,
});

export type FeatureFlagAction = SetFeatureFlags;
